"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Coveo = require("coveo-search-ui");
var OmniboxResultListHandler_1 = require("./OmniboxResultListHandler");
var Component = Coveo.Component;
var OmniboxResultList = (function (_super) {
    __extends(OmniboxResultList, _super);
    function OmniboxResultList(element, options, bindings) {
        _super.call(this, element, OmniboxResultList.ID, bindings);
        this.element = element;
        this.options = options;
        this.omniboxResultListHandler = new OmniboxResultListHandler_1.default();
        this.options = Coveo.ComponentOptions.initComponentOptions(element, OmniboxResultList, options);
        if (bindings) {
            this.initializeOmniboxDataRowIndex(bindings);
        }
        this.bind.onRootElement(Coveo.OmniboxEvents.populateOmnibox, this.populateOmnibox);
        this.bindEnterToSearchButton();
    }
    OmniboxResultList.prototype.bindEnterToSearchButton = function () {
        var queryBoxes = document.querySelectorAll(".CoveoSearchbox");
        _.map(queryBoxes, function (queryBox) {
            return {
                input: queryBox.querySelector("input"),
                button: queryBox.querySelector(".CoveoSearchButton")
            };
        }).filter(function (queryBoxElements) {
            return queryBoxElements.button !== null && queryBoxElements.input !== null;
        }).forEach(function (queryBoxElements) {
            queryBoxElements.input.addEventListener("keydown", function (event) {
                if (event.keyCode === 13) {
                    queryBoxElements.button.click();
                }
            });
        });
    };
    OmniboxResultList.prototype.populateOmnibox = function (populateOmniboxObject) {
        this.omniboxResultListHandler.populateOmniboxResultList(populateOmniboxObject, this.options, this.queryController);
    };
    OmniboxResultList.prototype.initializeOmniboxDataRowIndex = function (bindings) {
        var omniboxResultList = document.getElementsByClassName("CoveoForSitecoreOmniboxResultList")[0];
        if (!bindings.searchInterface.options.originalOptionsObject.keepOmniboxSuggestionsProvidersDefaultOrdering) {
            this.options.omniboxDataRowIndex = 51 + Coveo.$$(omniboxResultList).children().length - bindings.searchInterface.options.originalOptionsObject.omniboxDataRowIndexCounter;
            bindings.searchInterface.options.originalOptionsObject.omniboxDataRowIndexCounter++;
        }
    };
    OmniboxResultList.ID = "ForSitecoreOmniboxResultList";
    OmniboxResultList.options = {
        headerTitle: Coveo.ComponentOptions.buildStringOption(),
        queryExpression: Coveo.ComponentOptions.buildStringOption(),
        numberOfResults: Coveo.ComponentOptions.buildNumberOption({ defaultValue: 10, min: 1 }),
        omniboxDataRowIndex: Coveo.ComponentOptions.buildNumberOption({ defaultValue: 51, min: 16 }),
        resultTemplateId: Coveo.ComponentOptions.buildStringOption()
    };
    return OmniboxResultList;
}(Component));
exports.OmniboxResultList = OmniboxResultList;
Coveo.Initialization.registerAutoCreateComponent(OmniboxResultList);



//////////////////
// WEBPACK FOOTER
// ./Base/OmniboxResultList/OmniboxResultList.js
// module id = 22
// module chunks = 0